module.exports = __webpack_public_path__ + "static/media/clear.ada17d60.png";